import Home from './Home';

const ACTION = {
  ...Home.ACTION,
};

const ACTION_TYPES = {
  ...Home.ACTION_TYPES,
};

const Index = {
  ACTION,
  ACTION_TYPES
}

export default Index;